import postAudio from './postAudio';
import postVideo from './postVideo';
import postGallery from './postGallery';
import postVrViewer from './postVrViewer';
import post3dViewer from './post3dViewer';
import elementLink from './elementLink';
import mapButton from './mapButton';
import postChapter from './postChapter';
import postHeader from './postHeader';
import postPackageSyncStart from './postPackageSyncStart';
import postQuiz from './postQuiz';
import postRating from './postRating';
import post from './post';
import postTeaser from './postTeaser';
import postListEntry from './postListEntry';
import postImage from './postImage';
import postHeadline from './postHeadline';
import surveyAttributes from './surveyAttributes';
import elementVar from './elementVar';

const contentUI = [
	postAudio,
	postGallery,
	postVrViewer,
	post3dViewer,
	postChapter,
	postVideo,
	postHeader,
	postRating,
	elementLink,
	elementVar,
	mapButton,
	postPackageSyncStart,
	postQuiz,
	post,
	postTeaser,
	postListEntry,
	surveyAttributes,
	postImage,
	postHeadline,
];

let store;
// This function prevents circular depecies.
export function initializeConentUI(_store) {
	store = _store;
}

// Singelton for registred ContenUI modules by plugins
// It is used by webclient plugins
// Every Plugin is an Object  which has one function init and one function destroy both function are called with the context of the article component
export function registerPlugin(plugin) {
	contentUI.push(plugin);
}
export default {
	/**
	 *	this method is called every time the static html content of an article is initialised
	 * @param {*} context
	 */
	init(context) {
		contentUI.forEach(element => element.init && element.init.call(context, store));
	},
	destroy(context) {
		contentUI.forEach(element => element.destroy && element.destroy.call(context));
	},

	positionUpdated(context) {
		contentUI.forEach(element => element.positionUpdated && element.positionUpdated.call(context));
	},
	registerPlugin,
};
